<template>
  <div>
    <el-submenu v-if="item.children && item.children.length" :index="item.menuName">
      <template slot="title">
        <div style="position: relative">
          <span class="not-select">{{item.menuName}}</span>
        </div>
      </template>
      <template v-for="itemChild in item.children">
        <sidebar-item v-if="itemChild.children && itemChild.children.length" :key="itemChild.menuName" :item="itemChild"/>
        <el-menu-item v-else :key="itemChild.path" :index="itemChild.path" @click="goto(itemChild)">
          <i style="color: #fff; margin-right: 3px" class="iconfont circle"/>
          <span class="not-select">{{itemChild.menuName}}</span>
        </el-menu-item>
      </template>
    </el-submenu>
    <template v-else-if="item.path">
      <el-menu-item :index="item.menuIndex || item.path" :title="sidebarCollapsed ? item.menuName : ''" @click="goto(item)">
        <span class="not-select">{{item.menuName}}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
  export default {
    name: "SidebarItem",
    props: {
      sidebarCollapsed: Boolean,
      item: {
        type: Object,
        required: true,
      },
    },
    methods: {
      goto(menu) {
        this.$router.push({ path: menu.path });
      },
    },
  };
</script>
<style lang="scss" scoped>
.not-select {
  user-select: none;
}
::v-deep .el-submenu .el-menu-item{
  padding-right: 10px;
  min-width: 140px;
  box-sizing: border-box;
}
</style>
